import { render, staticRenderFns } from "./CalendariosPostagens.vue?vue&type=template&id=d62a61a2"
import script from "./CalendariosPostagens.vue?vue&type=script&lang=js"
export * from "./CalendariosPostagens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports